export default "__VITE_ASSET__BbFiboqe__"